// extracted by mini-css-extract-plugin
export default {"container":"CareElementWithFrequencyLabel_container__Qxs-j","careElementLabel":"CareElementWithFrequencyLabel_careElementLabel__Spo4b"};